module.exports = __webpack_public_path__ + "u3.no2.802b24d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u3.no2.jpg
// module id = 03gu
// module chunks = 0